import { render, staticRenderFns } from "./SelectCity.vue?vue&type=template&id=473b5ad4&scoped=true"
import script from "./SelectCity.vue?vue&type=script&lang=js"
export * from "./SelectCity.vue?vue&type=script&lang=js"
import style0 from "./SelectCity.vue?vue&type=style&index=0&id=473b5ad4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473b5ad4",
  null
  
)

export default component.exports